import { productionStateSelector } from '_clean-code/ducks/production/selectors';
import { useAppSelector } from '../../store';

export function useProductionConfig() {
  const productionSelector = useAppSelector(productionStateSelector);
  const productionConfig = productionSelector.productionConfig;
  return productionConfig;
}
